import { Cache, Texture } from 'pixi.js';

export class ResourcesStats {
    static getPixiCachedTexturesAllocatedMemory() {
        let totalMemory = 0;
        const cacheMap = (Cache as unknown as { _cache: Map<string, unknown> })._cache;
        for (const [, item] of cacheMap) {
            if (item instanceof Texture) {
                const textureSize =
                    (item.source.pixelWidth * item.source.pixelHeight * 4) / 1_000_000;
                totalMemory += textureSize;
            }
        }
        return totalMemory;
    }

    static getPixiCachedTexturesNumber() {
        let count = 0;
        const cacheMap = (Cache as unknown as { _cache: Map<string, unknown> })._cache;
        for (const [, item] of cacheMap) {
            if (item instanceof Texture) {
                count++;
            }
        }
        return count;
    }
}
